export default "__VITE_ASSET__DJXJUpQP__"